<template>
  <div class="p3 col-12 max-width-3">
    <h2 class="">{{$t('program_version_number_heading')}}</h2>
    <p class="">{{$t('program_version_number_number_12')}}</p>
    <h3 class="mt2">{{$t('program_copyright')}}</h3>
    <p>{{$t('program_copyright_company')}}</p>


    <!-- NOMENKLATUR VERSIONSNUMMER:  -->
    <!-- (Software).(letzte Ziffer Jahr)(Monat)(Tag)  -->
    <!-- Beispiel für Version released am 09. August 2023: -->
    <!-- 1.30809  -->

    <table class="GeneratedTable col-12 mt2">
      <thead>
        <tr>
          <th>{{$t('program_table_version_number_header')}}</th>
          <th>{{$t('program_table_valid_header')}}</th>
          <th>{{$t('program_table_changes_header')}}</th>
        </tr>
      </thead>
      <tbody>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_12')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_12')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_12_1')}}</li>
              <li>{{$t('program_table_update_decsription_12_2')}}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_11')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_11')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_11_1')}}</li>
              <li>{{$t('program_table_update_decsription_11_2')}}</li>
              <li>{{$t('program_table_update_decsription_11_3')}}</li>
              <li>{{$t('program_table_update_decsription_11_4')}}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_10')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_10')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_10_1')}}</li>
              <li>{{$t('program_table_update_decsription_10_2')}}</li>
              <li>{{$t('program_table_update_decsription_10_3')}}</li>
            </ul>
          </td>
        </tr>
        
        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_9')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_9')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_9')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_8')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_8')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_8')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_7')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_7')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_7')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_6')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_6')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_6')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_5')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_5')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_5')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_4')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_4')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_4')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_3')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_3')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_3')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number_2')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date_2')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription_2')}}</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_version_number')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_date')}}</li>
            </ul>
          </td>
          <td>
            <ul class="pl2">
              <li>{{$t('program_table_update_decsription')}}</li>
            </ul>
          </td>
        </tr>

      </tbody>
    </table>



  </div>
</template>

<script>

export default {
}
</script>

<style scoped>
th {
  color: white;
  background-color: var(--color-darkgray);
  text-align: left;
  padding: 1rem 0.55rem;
  font-size: 0.86rem
}

tr td {
  background: var(--color-verylightgray);
  padding: 0.5rem 0.55rem;
  font-size: 0.8rem
}
</style>
